
import { Component, OnInit } from '@angular/core';
import { BotCardType, ButtonCard, HtmlCard, IframeCard, ImageCard, VimeoCard, YoutubeCard } from '@shared/index';
import { SafePipe } from 'src/app/shared/pipes/safe.pipe';
import { ButtonCardComponent } from "../../../../shared/components/ai-bot/utils/bot-chat-dialog/message-card/button-card/button-card.component";

@Component({
  selector: 'app-card-modal',
  imports: [SafePipe, ButtonCardComponent],
  templateUrl: './cardModal.component.html',
  styleUrl: './cardModal.component.css'
})
export class CardModalComponent implements OnInit {
  public content: unknown = {};
  public type!: BotCardType;
  public youtubeCard!: YoutubeCard;
  public buttonCard!: ButtonCard;
  public htmlCard!: HtmlCard;
  public iframeCard!: IframeCard;
  public imageCard!: ImageCard;
  public vimeoCard!: VimeoCard;

  public ngOnInit(): void {
    this.type = (this.content as { type: BotCardType }).type;
    this.youtubeCard = this.content as YoutubeCard;
    this.buttonCard = this.content as ButtonCard;
    this.htmlCard = this.content as HtmlCard;
    this.iframeCard = this.content as IframeCard;
    this.imageCard = this.content as ImageCard;
    this.vimeoCard = this.content as VimeoCard;
  }
}